<template>
  <CustomSelect
    v-model="localValue"
    class="configurator-category-select"
    :class="{ 'configurator-category-select--disabled': disabled }"
    v-bind="{
      name,
      options,
      multiple,
      modalBreakpoint: Breakpoint.CONFIGURATOR_L,
      modalTargetSlot: 'body',
      modalClass: 'configurator-category-select__modal',
      modalOptions: {
        hideCloseButton: true,
      },
      optionLabelProp: 'name',
      optionValueProp: 'id',
      expandedByDefault,
      disabled,
      labelledBy,
      targetClass: 'configurator-category-select__target',
    }"
  >
    <template #value="scope">
      <slot name="value" v-bind="scope"></slot>
    </template>

    <template #option="scope">
      <slot name="option" v-bind="scope"></slot>
    </template>

    <template #btn-toggle>
      <slot name="btn-toggle"></slot>
    </template>

    <template #placeholder>
      <slot name="placeholder"></slot>
    </template>
  </CustomSelect>
</template>

<script>
import CustomSelect from '../CustomSelect';
import Select from '../../mixins/Select';
import { Breakpoint } from '../../utils/breakpoints';

export default {
  name: 'ConfiguratorCategorySelect',
  components: { CustomSelect },
  mixins: [Select],
  data() {
    return {
      Breakpoint,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-category-select {
  border: $configurator-category-select-vertical-border
    $configurator-category-select-border-color;
  border-radius: 0.25em;
  transition: border $default-transition-duration;

  &.custom-select--expanded {
    background-color: $configurator-category-select-invert;
    border-bottom-color: $configurator-category-select-invert;
    border-right-color: $configurator-category-select-vertical-border-color-expanded;
    border-left-color: $configurator-category-select-vertical-border-color-expanded;
    border-top-color: $configurator-category-select-vertical-border-color-expanded;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &--disabled {
    opacity: 0.5;
  }

  &__option {
    flex: 1;
    min-width: 0;
  }
}
</style>

<style lang="scss">
.configurator-category-select__target {
  padding: 0.5rem 0;

  @include breakpoint($breakpoint-l) {
    padding: 0;
  }

  .base-dropdown__target & {
    border-right: $configurator-category-select-vertical-border
      $configurator-category-select-vertical-border-color-expanded;
    border-bottom: $configurator-category-select-vertical-border
      $configurator-category-select-vertical-border-color-expanded;
    border-left: $configurator-category-select-vertical-border
      $configurator-category-select-vertical-border-color-expanded;
    background-color: $configurator-category-select-invert;
    border-bottom-left-radius: $configurator-category-select-border-radius;
    border-bottom-right-radius: $configurator-category-select-border-radius;
  }

  .custom-select-option-list__item-label {
    padding: 0.5rem 1.5rem;
    color: $color-arapawa;

    &:hover {
      background-color: color.adjust(
        $configurator-category-select-color,
        $lightness: 90%
      );
    }
  }

  .custom-select-option-list__item-input:checked
    + .custom-select-option-list__item-label {
    color: $color-black;
  }
}

.configurator-category-select__modal .base-modal__body {
  background-color: $configurator-category-select-invert;
}
</style>
